export default {
  ReadRequest: function(action, self, onsuccess, onfailed, filter, order, page) {
    return {
        data : {    
          filter: filter,
          order: order,
          page: page,
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        action: action,
        onsuccess : self.onReadSuccess,
        onfailed : self.onReadFailed,
    }
  },
  ReadReport: function(action, self, onsuccess, onfailed, filter, order, page) {
    return {
        data : {    
          filter: filter,
          order: order,
          page: page,    
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        action: action,
        onsuccess : self.onReadSuccess,
        onfailed : self.onReadFailed,
    }
  },
  Report: function(alias, self, onReportSuccess, onReportFailed) {
    return {
        data : {    
          alias: alias,
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        onsuccess : self.onReportSuccess,
        onfailed : self.onReportFailed,
    }
  },
  RegisterRequest: function(self, onRegisterSuccess, onRegisterFailed) {
    return {
        data : {    
          field: {
            Request        : self.state.request,
            Description    : self.state.description,
            ScheduledStart : self.state.scheduledStart_UTC,
            ScheduledEnd   : self.state.scheduledEnd_UTC,
            IsRepeating    : self.state.isRepeat,
            RepeatPeriod   : self.state.repeatPeriod,
            RepeatType     : self.state.repeatType,
            IsReminder     : self.state.isReminder,
            NextScheduled  : self.state.nextScheduled_UTC,
          },
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        onsuccess : self.onRegisterSuccess,
        onfailed : self.onRegisterFailed,
    }
  },
  RejectRequest: function(self, onRegisterSuccess, onRegisterFailed) {
    return {
        data : {    
          field: {
            Service        : self.RejectParams.Service,
            Description    : self.RejectParams.Description,
          },
          Alias : self.RejectParams.Alias,
          Asset : self.RejectParams.Asset,
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        onsuccess : onRegisterSuccess,
        onfailed : onRegisterFailed,
    }
  },
  RejectReport: function(self, onRegisterSuccess, onRegisterFailed, alias) {
    return {
        data : {    
          Alias : alias,
          // Asset : self.RejectParams.Asset,
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        onsuccess : onRegisterSuccess,
        onfailed : onRegisterFailed,
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/request/helper/request.props.js